import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useGNBHandler from "@/components/common/GNB/useGNBHandler";
import { cn } from "@/lib/utils";
import { LOGIN_PAGE, REGISTRATION_PAGE } from "@/settings/constant";
import { Button } from "@bookips/sds";
const GNBAuthButtons = (param)=>{
    let { className  } = param;
    const { handlePageMove  } = useGNBHandler();
    const handleLoginClick = ()=>{
        handlePageMove(LOGIN_PAGE, true);
    };
    const handleSignUpClick = ()=>{
        handlePageMove(REGISTRATION_PAGE, true);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex items-center gap-2", className),
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "md",
                onClick: handleLoginClick,
                children: "로그인"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "fill",
                color: "secondary",
                size: "md",
                onClick: handleSignUpClick,
                children: "회원가입"
            })
        ]
    });
};
export default GNBAuthButtons;
